// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__FieldDisplayOnly__fieldDisplayOnly__yHXvbH{color:var(--JDS-INPUT-FIELD-TEXT-COLOR-TEXT-DISPLAY-ONLY-INTERNAL)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/fields/internal/FieldLayout/FieldDisplayOnly.module.css"],"names":[],"mappings":"AAAA,iDACE,kEAAA","sourcesContent":[".fieldDisplayOnly {\n  color: var(--JDS-INPUT-FIELD-TEXT-COLOR-TEXT-DISPLAY-ONLY-INTERNAL);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldDisplayOnly": "jut__FieldDisplayOnly__fieldDisplayOnly__yHXvbH"
};
export default ___CSS_LOADER_EXPORT___;
